interface Environment {
  serverIP: string;
  serverPort: string;
  serverURL: string;
  isDevelopment: boolean;
}

export const environment: Environment = {
  serverIP: '0.0.0.0',
  serverPort: '8000',
  isDevelopment: process.env.NODE_ENV === 'development',
  get serverURL() {
      // The deployed app runs `react-scripts start`, so NODE_ENV is
      // 'development' even in production — decide by hostname instead.
      const isLocalhost = typeof window !== 'undefined' &&
          ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
      if (isLocalhost) {
          return `http://${this.serverIP}:${this.serverPort}`;
      }
      return 'https://amorino-be-usn27.ondigitalocean.app';
  }
};